import fetch from '@/utils/request'

const request = (rest = {}) => fetch({ ...rest, privateFlag: true })

export default {
  // 获取产品分类字典
  getCategoryDict(data) {
    return request({
      url: `/business/product/getCategoryDict`,
      method: 'POST',
      data
    })
  },
  // 产品线列表
  getProductLineList(data) {
    return request({
      url: `/business/product/getProductLineList`,
      method: 'POST',
      data
    })
  },
  // 添加产品线
  addProductLine(data) {
    return request({
      url: `/business/product/add`,
      method: 'POST',
      data
    })
  },
  // 编辑产品线
  updateProductLine(data) {
    return request({
      url: `/business/product/updateProductLine`,
      method: 'POST',
      data
    })
  },
  // 删除产品线
  deletedProductLine(data) {
    return request({
      url: `/business/product/deletedProductLine`,
      method: 'POST',
      data
    })
  },
  // 产品线排序
  sortProductLine(data) {
    return request({
      url: `/business/product/sortProductLine`,
      method: 'POST',
      data
    })
  },
  // 产品列表
  getProductList(data) {
    return request({
      url: `/business/product/getProductList`,
      method: 'POST',
      data
    })
  },
  // 导出产品列表
  exportProductList(data) {
    return request({
      url: `/business/product/export`,
      method: 'POST',
      data
    })
  },
  // 新增产品
  addProduct(data) {
    return request({
      url: `/business/product/addProduct`,
      method: 'POST',
      data
    })
  },
  // 编辑产品
  updateProduct(data) {
    return request({
      url: `/business/product/updateProduct`,
      method: 'POST',
      data
    })
  },
  // 删除品产
  deletedProduct(data) {
    return request({
      url: `/business/product/deletedProduct`,
      method: 'POST',
      data
    })
  },
  // 获取产品详情
  getProductDetail(data) {
    return request({
      url: `/business/product/getProductDetail`,
      method: 'POST',
      data
    })
  },
  // 产品启用停用
  updateProductType(data) {
    return request({
      url: `/business/product/updateProductType`,
      method: 'POST',
      data
    })
  },
  // 新增产品组
  addProductGroup(data) {
    return request({
      url: `/business/product/addProductGroup`,
      method: 'POST',
      data
    })
  },
  // 编辑产品组
  updateProductGroup(data) {
    return request({
      url: `/business/product/updateProductGroup`,
      method: 'POST',
      data
    })
  },
  // 删除产品组
  deletedProductGroup(data) {
    return request({
      url: `/business/product/deletedProductGroup`,
      method: 'POST',
      data
    })
  },
  /**
   * 获取全部产品树 三级结构
  */
  getAllProductGroupTree(data) {
    return request({
      url: '/business/product/getAllProductGroupTree',
      method: 'POST',
      data
    })
  },
  // 获取权限下产品树 三级结构
  getProductGroupTree(data) {
    return request({
      url: `/business/product/getProductGroupTree`,
      method: 'POST',
      data,
      isPermission: true
    })
  },
  /**
   * 获取全部产品树 二级结构
   */
  getAllProductListTree(data) {
    return request({
      url: `/business/product/getAllProductListTree`,
      method: 'POST',
      data
    })
  },
  /**
   * 获取权限产品树 二级结构
   */
  getProductListTree(data) {
    return request({
      url: `/business/product/getProductListTree`,
      method: 'POST',
      data,
      isPermission: true
    })
  }
}
